'use strict';

import { schema } from './schema.fn';

schema.$inject = ['fieldDefinitionService', 'htmlService', 'dateUtils', '$window', 'configuration', '$translate', '$moment'];
angular.module('kerp-forms.forms').factory('FCA_SCHEMA', schema);
